// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/search/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/search/searchHub */
export const useSearchHub = makeBackendHook('search', 'searchHub')
